/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const truncateString = (str: string, num: number) => {
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + "...";
};

export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
}

export function toCamelCase(str: string) {
  return str
    .toLowerCase()
    .replaceAll(/[^\dA-Za-z]/g, " ")
    .split(" ")
    .reduce((result, word) => result + capitalize(word));
}
